import axios from 'axios';

export async function savePaymentAgreement({ clientid, dealerid, charges, authSignature, clientSignature, insurance }) {
  const toFile = async (source, name) => {
    const response = await fetch(source);
    if (!response.ok) throw new Error('Unable to load signature. Please draw the signature again.');
    const blob = await response.blob();
    return new File([blob], name, { type: blob.type || 'image/png' });
  };
  const [authFile, clientFile] = await Promise.all([
    toFile(authSignature, 'authsign.png'), toFile(clientSignature, 'clientsign.png'),
  ]);
  const payload = new FormData();
  payload.append('clientid', clientid);
  payload.append('dealerid', dealerid);
  Object.entries(charges).forEach(([key, value]) => payload.append(key, String(value)));
  payload.append('paymentterms', '0');
  payload.append('insuranceterms', insurance ? '1' : '0');
  payload.append('authsign', authFile);
  payload.append('clientsign', clientFile);
  const response = await axios.post('https://alcobrakeadmin.com/v3/us/fullclients/createintpaymentterms', payload);
  if (response.data?.success === false || response.data?.status === false || response.data?.error ||
    (typeof response.data === 'string' && /error|fail|invalid/i.test(response.data))) {
    throw new Error(response.data?.message || 'Payment agreement could not be saved.');
  }
  return response.data;
}
